import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TruckOverviewActionBarComponent } from './component/truck-overview-action-bar.component';

import { DictionaryModule } from '@sdbn/common';
import { CommonLayoutModule, CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { MatTooltipModule as MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    TruckOverviewActionBarComponent
  ],
  imports: [
    CommonModule,
    DictionaryModule,

    CommonLayoutModule,
    CommonTranslationModule,
    CommonUIModule,
    MatTooltipModule
  ],
  exports: [
    TruckOverviewActionBarComponent
  ]
})
export class TruckOverviewActionBarModule { }
